export const RGBA = (opacity: number) => `rgba(200, 200, 255, ${opacity})`;
